import { render } from "./pricing-plans.vue?vue&type=template&id=6e371061&scoped=true"
import script from "./pricing-plans.vue?vue&type=script&lang=js"
export * from "./pricing-plans.vue?vue&type=script&lang=js"

import "./pricing-plans.vue?vue&type=style&index=0&id=6e371061&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e371061"]])

export default __exports__